var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    attrs: {
      "href": _vm.href,
      "target": _vm.newWindow ? '_blank' : ''
    }
  }, [_c('div', {
    staticClass: "gh-menuLink"
  }, [_c('div', {
    staticClass: "gh-menuLink__content"
  }, [_c('h3', [_vm._t("header")], 2), _vm._t("default")], 2), _c('div', {
    staticClass: "gh-menuIcon"
  }, [_c('icon-arrow-left', {
    staticClass: "gh-icon"
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };